import React from 'react';
import { WarningOutlined, LineChartOutlined } from '@ant-design/icons';
import { StrategySvg } from '@/assets/svg';
import type { AlertCardType } from '@/domain/Notifications/Notifications';
import type { CardType, TabKey } from './types';

export const STRATEGY_STALE_MINUTES = 35;

export const TAB_KEYS = {
	ALL: 'all',
	SYSTEM: 'system',
	FORECAST: 'forecast',
} as const;

export const mapTabToKind = (t: TabKey) =>
	t === TAB_KEYS.SYSTEM ? 'ISSUES' : t === TAB_KEYS.FORECAST ? 'RECOMMENDATIONS' : 'ALL';

export const CARD_CONFIG = {
	system: {
		accentColor: '#E8453C',
		borderColor: '#F5A9A6',
		cardBg: '#FFF4F4',
		icon: <WarningOutlined style={{ color: '#E8453C', fontSize: 20 }} />,
	},
	strategy: {
		accentColor: '#34C38F',
		borderColor: '#7DD9B8',
		cardBg: 'rgba(192, 239, 222, 0.35)',
		icon: <StrategySvg color="#34C38F" />,
	},
	'strategy-not-recommended': {
		accentColor: '#E8453C',
		borderColor: '#F5A9A6',
		cardBg: '#FFE4E4',
		icon: <StrategySvg color="#E8453C" />,
	},
	forecast: {
		accentColor: '#0097B2',
		borderColor: '#E6E6E6',
		cardBg: '#fff',
		icon: <LineChartOutlined style={{ color: '#000', fontSize: 20 }} />,
	},
	default: {
		accentColor: '#2E6FD0',
		borderColor: '#E6E6E6',
		cardBg: '#F5F9FF',
		icon: <LineChartOutlined style={{ color: '#2E6FD0', fontSize: 20 }} />,
	},
} as const;

export const chipStyle: React.CSSProperties = {
	padding: '5px 10px',
	background: '#fff',
	border: '1.5px solid #D0D5DD',
	borderRadius: 16,
	fontWeight: 500,
	fontSize: 12,
	color: '#4E5A66',
	display: 'inline-flex',
	alignItems: 'center',
	width: 'fit-content',
	whiteSpace: 'nowrap',
};

export function resolveCardType(act: AlertCardType): CardType {
	if (act.isHistoricalAlert === true) return 'system';
	if (act.type === 'RECOMMENDATION') return 'strategy';
	if (act.isHistoricalAlert === false || act.isHistoricalAlert == null) return 'forecast';
	return 'default';
}

export function resolveThresholdLabel(act: AlertCardType, unit: string): string {
	const val = typeof act.alertValue === 'string' ? Number.parseFloat(act.alertValue) : (act.alertValue ?? Number.NaN);
	if (!Number.isFinite(val)) return '-';
	if (act.maxThreshold != null && val > act.maxThreshold) return `Threshold: <${act.maxThreshold}${unit}`;
	if (act.minThreshold != null && val < act.minThreshold) return `Threshold: >${act.minThreshold}${unit}`;
	return '-';
}
